import { useState } from 'react';
import { convertBackgroundToNamedColor, generateClassName } from '@klv/shared/utils/functions';

import Icon from '@klv/atoms/icon';
import Buttons from '@klv/molecules/buttons';
import * as styles from './styles/comparisonChart.module.scss';
import parser from './parser';

import type { IComparisonChart } from './types';

const ComparisonChart = ({
  buttons = [],
  backgroundColor = 'lightSand',
  chart: { content = '' } = { content: '' },
  description = '',
  disclaimer = '',
  headline = '',
  showFlag = false,
  collapseChart = false,
  ...props
}: IComparisonChart) => {
  const namedBackgroundColor = convertBackgroundToNamedColor(backgroundColor);
  const parsedContent = parser(content);

  const [isCollapsed, setIsCollapsed] = useState(collapseChart);

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div
      className={generateClassName([styles.comparisonChart, styles[namedBackgroundColor]])}
      {...props}
    >
      <div className={`grid ${styles.grid}`}>
        {showFlag && (
          <Icon
            className={styles.flag}
            fillColor="currentColor"
            iconName="BugMarkFilled"
            size={3}
          />
        )}
        {(headline || description) && (
          <div className={styles.textContainer}>
            <div className={styles.header}>
              {collapseChart ? (
                <button
                  className={styles.displayChart}
                  onClick={handleToggleCollapse}
                  aria-label="Toggle chart visibility"
                >
                  <h2 className={styles.headline}>{headline}</h2>
                  <Icon
                    iconName="ChevronDown"
                    className={!isCollapsed ? styles.expandIcon : styles.collapseIcon}
                  />
                </button>
              ) : (
                <h2 className={styles.headline}>{headline}</h2>
              )}
            </div>
            {!isCollapsed && <div className={`p2 ${styles.description}`}>{description}</div>}
          </div>
        )}
        {!isCollapsed && (
          <>
            <div className={styles.chart}>{parsedContent}</div>
            {disclaimer && <div className={`disclaimer ${styles.disclaimer}`}>{disclaimer}</div>}
            {buttons && buttons.length > 0 && (
              <div className={styles.buttonsContainer}>
                <Buttons
                  buttons={buttons}
                  buttonColor={namedBackgroundColor === 'charcoal' ? 'light' : 'dark'}
                  variants={['primary']}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ComparisonChart;
